import api from 'api'
//import ticket from 'api/ticket'
import React, { useEffect, useState } from 'react'

interface props{
    item: any,
}
function Ticket({item}:props) {
    const [heading, setHeading]=useState<string>("");
    useEffect(()=>{
        //api.ticket.get(Id).then((r)=>console.log(r))
        console.log(item)
        let firstdot=item.Clip.Body.indexOf(".");
        let firstquestion=item.Clip.Body.indexOf("?");

        if(firstquestion<firstdot){
            firstdot=firstquestion;
        }


        setHeading(item.Clip.Body.substr(0,item.Clip.Body.indexOf("."))+"...");
    },[])

  return (
    <div>
        {heading}
    </div>
  )
}

export default Ticket;